import { CssBaseline, Dialog, DialogContent, DialogActions, Button, Typography, Box, Divider } from "@mui/material"
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {NavBar} from "./components/general/NavBar";
import {Homepage} from "./pages/Homepage";
import Contact from "./pages/Contact";
import {Pricelist} from "./pages/Pricelist";
import Footer from "./components/general/Footer";
import AboutMe from "./pages/AboutMe";
import { useState } from "react";

function App() {
    const [acknowledged, setAcknowledged] = useState(false);

    return (
        <>
            <BrowserRouter>
                <CssBaseline/>
                <Dialog
                    open={!acknowledged}
                    disableEscapeKeyDown
                    PaperProps={{
                        sx: {
                            backgroundColor: "#FCF8F3",
                            borderRadius: "16px",
                            boxShadow: "6px 8px 0px 0px #D3B89B",
                            maxWidth: "480px",
                            width: "100%",
                            overflow: "hidden",
                            position: "relative",
                        }
                    }}
                >
                    {/* Dog paw watermark */}
                    <Box sx={{ position: "absolute", bottom: 16, right: 16, pointerEvents: "none" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="127" height="138" viewBox="0 0 127 138" fill="none">
                            <path d="M87.3033 71.615C93.9418 77.4485 100.52 87.1121 103.693 99.0757C106.568 109.919 110.612 120.408 113.963 131.114C115.154 134.919 116.241 138.768 115.87 142.811C114.847 153.901 105.449 163.244 94.282 164.739C84.1865 166.091 76.0895 162.04 68.6912 155.941C64.3186 152.332 59.8615 148.88 55.0371 145.921C48.6769 142.026 41.516 140.975 34.262 140.19C25.9763 139.287 18.0026 137.55 10.7133 133.067C-0.482391 126.186 -3.61285 108.805 4.72395 98.6817C8.48969 94.1151 13.2583 90.8045 18.211 87.7802C26.0457 82.9968 33.4845 77.7318 40.2184 71.4787C47.8672 64.3768 57.1635 61.9736 67.3078 62.3659C75.5799 62.6843 78.0541 63.7904 87.3114 71.6054L87.3033 71.615Z" fill="#E19016" fillOpacity="0.1"/>
                            <path d="M68.3364 13.1576C72.1775 9.27683 77.2882 4.96134 83.3819 1.77044C94.4043 -3.99011 105.222 5.37144 106.386 14.5747C107.317 21.9604 105.477 28.611 101.655 34.833C96.9653 42.4679 90.8452 48.5187 82.4025 51.9864C80.0839 52.9439 77.6548 53.4315 75.1753 53.3198C69.8157 53.0856 65.8894 50.77 63.4925 45.717C58.5329 35.2255 59.9693 23.0265 68.3187 13.159L68.3364 13.1576Z" fill="#E19016" fillOpacity="0.1"/>
                            <path d="M15.3873 25.3961C18.3735 22.0219 20.8201 18.5687 24.4025 16.1562C30.6331 11.951 37.652 12.8981 42.1979 18.7827C46.8233 24.7672 48.6301 31.4672 46.9491 38.9564C44.9424 47.8574 41.3705 55.8956 33.7326 61.4346C27.9461 65.6381 21.4252 66.3887 14.633 64.4375C10.8089 63.3381 8.8799 60.1539 7.81544 56.6843C5.31374 48.4807 5.71351 40.3356 9.63921 32.5961C11.0795 29.7508 13.6511 27.6805 15.3777 25.3881L15.3873 25.3961Z" fill="#E19016" fillOpacity="0.1"/>
                            <path d="M110.879 44.1595C114.193 40.3408 118.049 37.2753 122.615 35.2508C131.453 31.3151 141.215 35.7242 143.714 45.0552C146.277 54.6205 144.775 63.7188 138.075 71.2116C133.062 76.8057 126.785 80.9882 119.558 83.4842C117.27 84.2706 114.89 84.6032 112.493 84.3159C107.377 83.6975 104.834 80.192 103.883 75.6391C101.469 64.1356 103.745 53.579 110.879 44.1595Z" fill="#E19016" fillOpacity="0.1"/>
                            <path d="M128.527 91.563C133.296 85.9272 140.088 83.9646 146.849 86.4953C151.766 88.3374 154.131 92.266 155.189 97.0407C156.838 104.508 155.984 111.795 152.514 118.609C148.782 125.906 141.331 128.377 133.425 125.223C122.954 121.051 118.849 111.641 123.026 101.183C124.347 97.8595 125.841 94.6014 128.544 91.5615L128.527 91.563Z" fill="#E19016" fillOpacity="0.1"/>
                        </svg>
                    </Box>

                    <DialogContent sx={{ padding: { xs: "24px 24px 16px 24px", sm: "40px 40px 24px 40px" } }}>
                        <Typography sx={{
                            fontFamily: "Barlow, sans-serif",
                            fontSize: { xs: "20px", sm: "24px" },
                            fontWeight: 600,
                            color: "#E39B3B",
                            marginBottom: "16px",
                        }}>
                            Momenteel geen nieuwe klanten
                        </Typography>
                        <Divider sx={{ borderColor: "#E39B3B", marginBottom: "20px" }} />
                        <Typography sx={{
                            fontFamily: "Barlow, sans-serif",
                            fontSize: { xs: "16px", sm: "18px" },
                            fontWeight: 500,
                            color: "#3B3026",
                            lineHeight: 1.6,
                        }}>
                            Bedankt voor uw interesse in MiniMax! Op dit moment zijn wij helaas volledig volgeboekt en nemen wij geen nieuwe klanten aan. Wij hopen u in de toekomst te mogen verwelkomen.
                        </Typography>
                    </DialogContent>

                    <DialogActions sx={{ padding: { xs: "0 24px 24px 24px", sm: "0 40px 40px 40px" }, justifyContent: "flex-start" }}>
                        <Button
                            onClick={() => setAcknowledged(true)}
                            sx={{
                                backgroundColor: "#E19117",
                                color: "#fff",
                                fontFamily: "Barlow, sans-serif",
                                fontSize: { xs: "16px", sm: "18px" },
                                fontWeight: 500,
                                borderRadius: "8px",
                                padding: { xs: "8px 20px", sm: "10px 28px" },
                                textTransform: "none",
                                "&:hover": { backgroundColor: "#c97e10" },
                            }}
                        >
                            Ik begrijp het
                        </Button>
                    </DialogActions>
                </Dialog>

                <NavBar />
                <Routes>
                    <Route path="/" element={<Homepage />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/prijslijst" element={<Pricelist />} />
                    <Route path="/about" element={<AboutMe />} />
                </Routes>
                <Footer/>
            </BrowserRouter>
        </>
    )
}

export default App
